// Curated pool of hero-eligible images for the homepage showcase.
// This is a hand-picked "best of" set. The `homepageHero: "first-visit"`
// entry (Shy Boy hero) is pinned to slot 0 on a visitor's very first load;
// every subsequent visit reshuffles freshly and Shy Boy is never re-pinned.

// ─── Shy Boy ───
import shyBoyHeroAsset from "@/assets/projects/shy-boy-hero.jpg.asset.json";
const shyBoyHero = shyBoyHeroAsset.url;
import shyBoy02Asset from "@/assets/projects/shy-boy-02.jpg.asset.json";
const shyBoy02 = shyBoy02Asset.url;
import shyBoy09Asset from "@/assets/projects/shy-boy-09.webp.asset.json";
const shyBoy09 = shyBoy09Asset.url;

// ─── The Creamery ───
import creameryFacadeAsset from "@/assets/creamery/facade-final.webp.asset.json";
const creameryFacade = creameryFacadeAsset.url;
import creameryGallery02Asset from "@/assets/creamery/gallery-02.webp.asset.json";
const creameryGallery02 = creameryGallery02Asset.url;
import creameryGallery06Asset from "@/assets/creamery/gallery-06.webp.asset.json";
const creameryGallery06 = creameryGallery06Asset.url;

// ─── Effy Jewelry ───
import effyHeroAsset from "@/assets/projects/effy-jewelry-hero.webp.asset.json";
const effyHero = effyHeroAsset.url;
import effyLoungeAsset from "@/assets/projects/effy-jewelry-lounge.webp.asset.json";
const effyLounge = effyLoungeAsset.url;

// ─── Grupo Bafar ───
import bafarHeroAsset from "@/assets/projects/bafar/bafar-hero.png.asset.json";
const bafarHero = bafarHeroAsset.url;
import bafar02Asset from "@/assets/projects/bafar/bafar-02.webp.asset.json";
const bafar02 = bafar02Asset.url;
import bafar13Asset from "@/assets/projects/bafar/bafar-13.webp.asset.json";
const bafar13 = bafar13Asset.url;
import bafar16Asset from "@/assets/projects/bafar/bafar-16.webp.asset.json";
const bafar16 = bafar16Asset.url;

// ─── Even Coast ───
import evenCoastBarFrontAsset from "@/assets/projects/even-coast/bar-front-day.webp.asset.json";
const evenCoastBarFront = evenCoastBarFrontAsset.url;
import evenCoastDiningNightAsset from "@/assets/projects/even-coast/dining-night-chandelier.webp.asset.json";
const evenCoastDiningNight = evenCoastDiningNightAsset.url;

// ─── Media Monks ───
import mmAtriumDayAsset from "@/assets/projects/media-monks/atrium-day.webp.asset.json";
const mmAtriumDay = mmAtriumDayAsset.url;
import mmAtriumTreeAsset from "@/assets/projects/media-monks/atrium-tree-day.webp.asset.json";
const mmAtriumTree = mmAtriumTreeAsset.url;
import mmKitchenDayAsset from "@/assets/projects/media-monks/kitchen-day.webp.asset.json";
const mmKitchenDay = mmKitchenDayAsset.url;

// ─── Uno South Pointe ───
import unoLobbyAsset from "@/assets/projects/uno-south-miami/lobby-overview.webp.asset.json";
const unoLobby = unoLobbyAsset.url;
import unoReceptionAsset from "@/assets/projects/uno-south-miami/reception-front.webp.asset.json";
const unoReception = unoReceptionAsset.url;

// ─── Birkenstock ───
import birkenstockWorkspaceAsset from "@/assets/birkenstock-workspace-wide.webp.asset.json";
const birkenstockWorkspace = birkenstockWorkspaceAsset.url;
import birkenstockLoungeAsset from "@/assets/birkenstock-lounge-front.webp.asset.json";
const birkenstockLounge = birkenstockLoungeAsset.url;
import birkenstockBoardroomAsset from "@/assets/birkenstock-boardroom-table.webp.asset.json";
const birkenstockBoardroom = birkenstockBoardroomAsset.url;

// ─── Private Penthouse ───
import ppHeroAsset from "@/assets/private-penthouse-hero.webp.asset.json";
const ppHero = ppHeroAsset.url;
import ppHeroMobileAsset from "@/assets/private-penthouse-hero-mobile.webp.asset.json";
const ppHeroMobile = ppHeroMobileAsset.url;
import ppLivingAsset from "@/assets/private-penthouse-living.webp.asset.json";
const ppLiving = ppLivingAsset.url;
import ppLiving3Asset from "@/assets/private-penthouse-living-3.webp.asset.json";
const ppLiving3 = ppLiving3Asset.url;
import ppShelves2Asset from "@/assets/private-penthouse-shelves-2.webp.asset.json";
const ppShelves2 = ppShelves2Asset.url;
import ppShelvesMobileAsset from "@/assets/projects/private-penthouse/private-penthouse-shelves-mobile.webp.asset.json";
const ppShelvesMobile = ppShelvesMobileAsset.url;

// ─── Private Residence ───
import prHeroAsset from "@/assets/private-residence-hero.webp.asset.json";
const prHero = prHeroAsset.url;
import prHeroDesktopAsset from "@/assets/private-residence-hero-desktop.webp.asset.json";
const prHeroDesktop = prHeroDesktopAsset.url;
import prSculptureAsset from "@/assets/private-residence-sculpture.webp.asset.json";
const prSculptureMobile = prSculptureAsset.url;
import prSculptureWideAsset from "@/assets/private-residence-sculpture-wide.webp.asset.json";
const prSculpture = prSculptureWideAsset.url;
import prStairAscentAsset from "@/assets/private-residence-stair-ascent.webp.asset.json";
const prStairAscent = prStairAscentAsset.url;

// ─── Casa MS (direct CDN URLs — no .asset.json for 4/9) ───
const casaMs1 = "/__l5e/assets-v1/f84c213b-28ab-4f2f-add2-28fd5c0da444/casa-ms-1.webp";
const casaMs4 = "/__l5e/assets-v1/7c12007e-f838-4a0d-9ecb-b08b5c107257/proyectos_obj32_large_4.png";
const casaMs9 = "/__l5e/assets-v1/d433f690-a8db-4668-ba44-9e6b9ca624c7/casa-ms-11.png";
// Casa MS 11 (as requested) — mapped to a strong "Casa MS 11" candidate
// from the gallery. The source set peaks at 9; using large_8 as the closest
// strong architectural moment in the same series.
const casaMs11 = "/__l5e/assets-v1/0aa4630b-583a-4e13-ae54-2d09db7bbb28/proyectos_obj32_large_8.png";
const casaMsLiving = "/__l5e/assets-v1/5dd21605-0e9e-4891-8d7d-536ec3c0bdb0/casa-ms-9.png";

// ─── El Paso Star ───
import elPasoStar3Asset from "@/assets/el-paso-star-3.jpg.asset.json";
const elPasoStar3 = elPasoStar3Asset.url;
// Existing project photography (also used on the El Paso Star project page).
const elPasoStarLeftSide = "/__l5e/assets-v1/f66cdee9-a599-4e79-b27c-88f09943e72c/proyectos_obj3_large_Star_Left_Side_COmpressed.jpg";
const elPasoStarRightSide = "/__l5e/assets-v1/2ded06df-dc24-4098-87b1-cf29e247cbbf/proyectos_obj3_large_Star_Right_Side_Compressed.jpg";

// ─── Rappi ───
const rappiMural = "/__l5e/assets-v1/e50af33b-36f6-4afa-972a-a1a79d657157/rappi-open-floor-mural.jpg";
const rappi9 = "/__l5e/assets-v1/28e4080e-b002-4def-8b2d-3425d5b0adbf/proyectos_obj6_large_9__Rappi_CDMX_LBAMStudio_16.jpg";
const rappi11 = "/__l5e/assets-v1/f12cb2ab-85fb-448d-b52e-c807d9dfa5b6/proyectos_obj6_large_Rappi_CDMX_LBAMStudio_115.jpg";
const rappi12 = "/__l5e/assets-v1/205c3280-4c04-457c-b9fd-418a0ea81456/proyectos_obj6_large_Rappi_CDMX_LBAMStudio_122.jpg";
import rappiCafeteriaAsset from "@/assets/rappi-cafeteria.jpg.asset.json";
const rappiCafeteria = rappiCafeteriaAsset.url;

// ─── Speak Easy ───
import speakEasy2Asset from "@/assets/projects/legacy/proyectos_obj7_large_3__SPEAKESAY_16MAR___66.jpg.asset.json";
const speakEasy2 = speakEasy2Asset.url;
import speakEasy4Asset from "@/assets/projects/legacy/proyectos_obj7_large_5__SPEAKESAY_16MAR___3___1.jpg.asset.json";
const speakEasy4 = speakEasy4Asset.url;

// ─── Tekmovil ───
const tekmovil1 = "/__l5e/assets-v1/2d59749a-48dd-41b5-ab1b-a128bb7983c5/proyectos_obj2_big_6l7p2n4x.jpg";
const tekmovil4 = "/__l5e/assets-v1/47deef39-abd4-418c-bf55-a63510cd1753/proyectos_obj2_large_4__Tekmovil_Ovier_MAR21_11.jpg";

// ─── Telemundo ───
const telemundo1 = "/__l5e/assets-v1/511e2985-e7f4-4aa0-b89b-74c16c6dda62/proyectos_obj1_big_sw9jam7x.jpg";
const telemundo2 = "/__l5e/assets-v1/2bfa9bbf-ceed-4fa6-b6f4-8ebd6da377f2/proyectos_obj1_large_TELEMUNDO___33.jpg";
const telemundo6 = "/__l5e/assets-v1/55067c19-6447-4dd5-91d1-4be880e06a1b/proyectos_obj1_large_TELEMUNDO__255.jpg";
const telemundo7 = "/__l5e/assets-v1/1e83c451-65ab-4111-9dc5-22471e2c3b0d/proyectos_obj1_large_TELEMUNDO__215.jpg";
const telemundoControlRoom = "/__l5e/assets-v1/05ad7af0-9335-4c26-bb33-4fa9aacd3fe8/telemundo-control-room.jpg";
const telemundoLounge = "/__l5e/assets-v1/aeb46953-d947-4820-ac33-f9852993c509/telemundo-lounge.jpg";
const telemundoNewsroomWide = "/__l5e/assets-v1/412ce368-c277-4737-8f41-2e89dd9f77fd/telemundo-newsroom-wide.jpg";
const luminousCorridor = "/__l5e/assets-v1/70801750-293d-4ebe-956e-aeaf5e747881/luminous-corridor.webp";

import { priorityBySlug } from "@/data/projects/priority";

export type HeroCandidate = {
  slug: string;
  name: string;
  sector: string;
  service: "Lighting Design" | "In Progress";
  src: string;
  alt: string;
  caption: string;
  priority: 1 | 2 | 3 | 4 | 5;
  updated: string;
  homepageHero?: "always" | "never" | "first-visit";
  photoQuality: "final" | "in-progress";
  mobileCropSafe: boolean;
  /** CSS object-position for desktop / default (e.g. "50% 40%"). */
  position?: string;
  /** CSS object-position for mobile (viewport < 768px). Falls back to `position` then "center". */
  positionMobile?: string;
  /** Optional object-fit override. Defaults to "cover". Use "contain" to zoom out and show entire image with charcoal letterbox. */
  fit?: "cover" | "contain";
  srcMobile?: string;
  /** If true, this slide only appears on mobile viewports (< 768px). */
  mobileOnly?: boolean;
  releaseLabel?: string;
};

/** Compress the editorial rank into 5 tiers for the scoring engine. */
const tier = (slug: string): 1 | 2 | 3 | 4 | 5 => {
  const r = priorityBySlug(slug);
  if (r <= 2) return 1;
  if (r <= 5) return 2;
  if (r <= 8) return 3;
  if (r <= 11) return 4;
  return 5;
};

const HOSP = "Hospitality · Lighting Design";
const WORK = "Workplace · Lighting Design";
const RES = "Upscale Residential · Lighting Design";
const URBAN = "Urban · Mixed-Use Identity";
const CIVIC = "Civic · Public Lighting System";
const RETAIL = "Retail · Lighting Design";

const updated = "2026-06-01";

export const HERO_CANDIDATES: HeroCandidate[] = [
  // Shy Boy — first-visit pin on hero
  { slug: "shy-boy", name: "Shy Boy", sector: "Hospitality", service: "Lighting Design",
    src: shyBoyHero, alt: "Shy Boy hospitality interior with sculpted architectural light",
    caption: HOSP, priority: tier("shy-boy"), updated, photoQuality: "final", mobileCropSafe: true,
    positionMobile: "50% 45%", homepageHero: "first-visit" },
  { slug: "shy-boy", name: "Shy Boy", sector: "Hospitality", service: "Lighting Design",
    src: shyBoy02, alt: "Shy Boy intimate bar lighting moment",
    caption: HOSP, priority: tier("shy-boy"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "shy-boy", name: "Shy Boy", sector: "Hospitality", service: "Lighting Design",
    src: shyBoy09, alt: "Shy Boy hospitality lighting composition",
    caption: HOSP, priority: tier("shy-boy"), updated, photoQuality: "final", mobileCropSafe: true,
    positionMobile: "54% 50%" },

  // The Creamery
  { slug: "the-creamery", name: "The Creamery", sector: "Adaptive Reuse", service: "Lighting Design",
    src: creameryFacade, alt: "The Creamery façade final lighting composition",
    caption: URBAN, priority: tier("the-creamery"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "the-creamery", name: "The Creamery", sector: "Adaptive Reuse", service: "Lighting Design",
    src: creameryGallery06, alt: "The Creamery exterior lighting composition",
    caption: URBAN, priority: tier("the-creamery"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "the-creamery", name: "The Creamery", sector: "Adaptive Reuse", service: "Lighting Design",
    src: creameryGallery02, alt: "The Creamery mixed-use façade lighting",
    caption: URBAN, priority: tier("the-creamery"), updated, photoQuality: "final", mobileCropSafe: true },

  // Effy Jewelry
  { slug: "effy-jewelry", name: "Effy Jewelry", sector: "Retail", service: "Lighting Design",
    src: effyHero, alt: "Effy Jewelry retail display lighting",
    caption: RETAIL, priority: tier("effy-jewelry"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "effy-jewelry", name: "Effy Jewelry", sector: "Retail", service: "Lighting Design",
    src: effyLounge, alt: "Effy Jewelry lounge with layered hospitality lighting",
    caption: RETAIL, priority: tier("effy-jewelry"), updated, photoQuality: "final", mobileCropSafe: true },

  // Grupo Bafar
  { slug: "grupo-bafar", name: "Grupo Bafar", sector: "Office Space", service: "Lighting Design",
    src: bafarHero, alt: "Grupo Bafar corporate offices hero",
    caption: WORK, priority: tier("bafar"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "grupo-bafar", name: "Grupo Bafar", sector: "Office Space", service: "Lighting Design",
    src: bafar02, alt: "Grupo Bafar workplace lighting composition",
    caption: WORK, priority: tier("bafar"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "grupo-bafar", name: "Grupo Bafar", sector: "Office Space", service: "Lighting Design",
    src: bafar13, alt: "Grupo Bafar corporate interior lighting",
    caption: WORK, priority: tier("bafar"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "grupo-bafar", name: "Grupo Bafar", sector: "Office Space", service: "Lighting Design",
    src: bafar16, alt: "Grupo Bafar architectural workspace lighting",
    caption: WORK, priority: tier("bafar"), updated, photoQuality: "final", mobileCropSafe: true },

  // Even Coast
  { slug: "even-coast", name: "Even Coast", sector: "Hospitality", service: "Lighting Design",
    src: evenCoastBarFront, alt: "Even Coast bar front daylight composition",
    caption: HOSP, priority: tier("even-coast"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "even-coast", name: "Even Coast", sector: "Hospitality", service: "Lighting Design",
    src: evenCoastDiningNight, alt: "Even Coast dining room at night under chandelier light",
    caption: HOSP, priority: tier("even-coast"), updated, photoQuality: "final", mobileCropSafe: true },

  // Casa MS
  { slug: "casa-ms", name: "Casa MS", sector: "Upscale Residential", service: "Lighting Design",
    src: casaMs1, alt: "Casa MS residence with refined architectural lighting",
    caption: RES, priority: tier("casa-ms"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "casa-ms", name: "Casa MS", sector: "Upscale Residential", service: "Lighting Design",
    src: casaMs4, alt: "Casa MS interior with layered lighting",
    caption: RES, priority: tier("casa-ms"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "casa-ms", name: "Casa MS", sector: "Upscale Residential", service: "Lighting Design",
    src: casaMs9, alt: "Casa MS architectural lighting composition",
    caption: RES, priority: tier("casa-ms"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "casa-ms", name: "Casa MS", sector: "Upscale Residential", service: "Lighting Design",
    src: casaMs11, alt: "Casa MS residence lighting moment",
    caption: RES, priority: tier("casa-ms"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "casa-ms", name: "Casa MS", sector: "Upscale Residential", service: "Lighting Design",
    src: casaMsLiving, alt: "Casa MS living room with sculptural linear ceiling lighting",
    caption: RES, priority: tier("casa-ms"), updated, photoQuality: "final", mobileCropSafe: true },

  // El Paso Star
  { slug: "el-paso-star", name: "El Paso Star", sector: "Public Works", service: "Lighting Design",
    src: elPasoStar3, alt: "El Paso Star civic lighting installation",
    caption: CIVIC, priority: tier("el-paso-star"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "el-paso-star", name: "El Paso Star", sector: "Public Works", service: "Lighting Design",
    src: elPasoStarLeftSide, alt: "El Paso Star illuminated on the Franklin Mountains, left side",
    caption: CIVIC, priority: tier("el-paso-star"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "el-paso-star", name: "El Paso Star", sector: "Public Works", service: "Lighting Design",
    src: elPasoStarRightSide, alt: "El Paso Star illuminated on the Franklin Mountains, right side",
    caption: CIVIC, priority: tier("el-paso-star"), updated, photoQuality: "final", mobileCropSafe: true },

  // Rappi
  { slug: "rappi", name: "Rappi", sector: "Office Space", service: "Lighting Design",
    src: rappi11, alt: "Rappi workplace lighting composition",
    caption: WORK, priority: tier("rappi"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "rappi", name: "Rappi", sector: "Office Space", service: "Lighting Design",
    src: rappi12, alt: "Rappi office lighting moment",
    caption: WORK, priority: tier("rappi"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "rappi", name: "Rappi", sector: "Office Space", service: "Lighting Design",
    src: rappiMural, alt: "Rappi open-floor workspace with mural backdrop",
    caption: WORK, priority: tier("rappi"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "rappi", name: "Rappi", sector: "Office Space", service: "Lighting Design",
    src: rappiCafeteria, alt: "Rappi cafeteria with linear pendant over communal table",
    caption: WORK, priority: tier("rappi"), updated, photoQuality: "final", mobileCropSafe: true },

  // Speak Easy
  { slug: "speak-easy", name: "Speak Easy", sector: "Hospitality", service: "Lighting Design",
    src: speakEasy2, alt: "Speak Easy interior with accent lighting",
    caption: HOSP, priority: tier("speak-easy"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "speak-easy", name: "Speak Easy", sector: "Hospitality", service: "Lighting Design",
    src: speakEasy4, alt: "Speak Easy interior with perimeter cove glow",
    caption: HOSP, priority: tier("speak-easy"), updated, photoQuality: "final", mobileCropSafe: true },

  // Tekmovil
  { slug: "tekmovil", name: "Tekmovil", sector: "Office Space", service: "Lighting Design",
    src: tekmovil1, alt: "Tekmovil workplace with integrated architectural lighting",
    caption: WORK, priority: tier("tekmovil"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "tekmovil", name: "Tekmovil", sector: "Office Space", service: "Lighting Design",
    src: tekmovil4, alt: "Tekmovil meeting room with suspended linear fixtures",
    caption: WORK, priority: tier("tekmovil"), updated, photoQuality: "final", mobileCropSafe: true },

  // Telemundo
  { slug: "telemundo", name: "Telemundo", sector: "Office Space", service: "Lighting Design",
    src: telemundo2, alt: "Telemundo office with diffused rounded pendants",
    caption: WORK, priority: tier("telemundo"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "telemundo", name: "Telemundo", sector: "Office Space", service: "Lighting Design",
    src: telemundo6, alt: "Telemundo brand accent lighting along architectural surfaces",
    caption: WORK, priority: tier("telemundo"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "telemundo", name: "Telemundo", sector: "Office Space", service: "Lighting Design",
    src: telemundoControlRoom, alt: "Telemundo control room with layered ceiling lighting",
    caption: WORK, priority: tier("telemundo"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "telemundo", name: "Telemundo", sector: "Office Space", service: "Lighting Design",
    src: telemundoLounge, alt: "Telemundo lounge with sculptural circular ceiling fixtures",
    caption: WORK, priority: tier("telemundo"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "telemundo", name: "Telemundo", sector: "Office Space", service: "Lighting Design",
    src: telemundoNewsroomWide, alt: "Telemundo newsroom with linear ceiling coves and branded wall",
    caption: WORK, priority: tier("telemundo"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "codelumen-labs", name: "codelumenLabs", sector: "Experience Center", service: "Lighting Design",
    src: luminousCorridor, alt: "Luminous corridor framed by continuous linear light lines",
    caption: "codelumenLabs · Experience Center", priority: 2, updated, photoQuality: "final", mobileCropSafe: true },

  // Media Monks
  { slug: "media-monks", name: "Media Monks", sector: "Office Space", service: "Lighting Design",
    src: mmAtriumDay, alt: "Media Monks atrium with daylight and layered ambient lighting",
    caption: WORK, priority: tier("media-monks"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "media-monks", name: "Media Monks", sector: "Office Space", service: "Lighting Design",
    src: mmAtriumTree, alt: "Media Monks atrium tree lit in daylight ambient",
    caption: WORK, priority: tier("media-monks"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "media-monks", name: "Media Monks", sector: "Office Space", service: "Lighting Design",
    src: mmKitchenDay, alt: "Media Monks kitchen with warm daytime lighting",
    caption: WORK, priority: tier("media-monks"), updated, photoQuality: "final", mobileCropSafe: true },

  // Uno South Pointe
  { slug: "uno-south-pointe", name: "Uno South Pointe", sector: "Office Space", service: "Lighting Design",
    src: unoLobby, alt: "Uno South Pointe lobby overview",
    caption: WORK, priority: tier("uno-south-pointe"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "uno-south-pointe", name: "Uno South Pointe", sector: "Office Space", service: "Lighting Design",
    src: unoReception, alt: "Uno South Pointe reception front lighting",
    caption: WORK, priority: tier("uno-south-pointe"), updated, photoQuality: "final", mobileCropSafe: true },

  // Birkenstock
  { slug: "birkenstock", name: "Birkenstock", sector: "Office Space", service: "Lighting Design",
    src: birkenstockLounge, alt: "Birkenstock lounge with warm hospitality-grade ambient lighting",
    caption: WORK, priority: tier("birkenstock"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "birkenstock", name: "Birkenstock", sector: "Office Space", service: "Lighting Design",
    src: birkenstockWorkspace, alt: "Birkenstock workspace with refined architectural lighting",
    caption: WORK, priority: tier("birkenstock"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "birkenstock", name: "Birkenstock", sector: "Office Space", service: "Lighting Design",
    src: birkenstockBoardroom, alt: "Birkenstock boardroom table with balanced lighting",
    caption: WORK, priority: tier("birkenstock"), updated, photoQuality: "final", mobileCropSafe: true,
    positionMobile: "center 40%" },

  // Private Penthouse
  { slug: "private-penthouse", name: "Private Penthouse", sector: "Upscale Residential", service: "Lighting Design",
    src: ppLiving3, alt: "Manhattan penthouse living room with layered ambient lighting",
    caption: RES, priority: tier("private-penthouse"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "private-penthouse", name: "Private Penthouse", sector: "Upscale Residential", service: "Lighting Design",
    src: ppShelves2, srcMobile: ppShelvesMobile, alt: "Manhattan penthouse shelving with integrated lighting",
    caption: RES, priority: tier("private-penthouse"), updated, photoQuality: "final", mobileCropSafe: true,
    positionMobile: "50% 50%" },
  { slug: "private-penthouse", name: "Private Penthouse", sector: "Upscale Residential", service: "Lighting Design",
    src: ppHero, srcMobile: ppHeroMobile,
    alt: "Manhattan penthouse dining room with layered sconce lighting and skyline view",
    caption: RES, priority: tier("private-penthouse"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "private-penthouse", name: "Private Penthouse", sector: "Upscale Residential", service: "Lighting Design",
    src: ppLiving, alt: "Manhattan penthouse living room with opal glass cluster pendants",
    caption: RES, priority: tier("private-penthouse"), updated, photoQuality: "final", mobileCropSafe: true },

  // Private Residence
  { slug: "private-residence", name: "Private Residence", sector: "Upscale Residential", service: "Lighting Design",
    src: prHeroDesktop, alt: "Private residence hero interior with refined ambient lighting",
    caption: RES, priority: tier("private-residence"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "private-residence", name: "Private Residence", sector: "Upscale Residential", service: "Lighting Design",
    src: prHero, alt: "Private residence interior with refined ambient lighting",
    caption: RES, priority: tier("private-residence"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "private-residence", name: "Private Residence", sector: "Upscale Residential", service: "Lighting Design",
    src: prSculpture, srcMobile: prSculptureMobile, alt: "Private residence sculpture with accent lighting",
    caption: RES, priority: tier("private-residence"), updated, photoQuality: "final", mobileCropSafe: true },
  { slug: "private-residence", name: "Private Residence", sector: "Upscale Residential", service: "Lighting Design",
    src: prStairAscent, alt: "Private residence stair ascent with integrated cove lighting and sconce",
    caption: RES, priority: tier("private-residence"), updated, photoQuality: "final", mobileCropSafe: true,
    mobileOnly: true },
];
